import 'twin.macro';
import React from 'react';
import { DateNavigator } from '@teetsh/app/src/containers/CahierJournal/Toolbar/DateNavigator';
import { Actions } from './Actions';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';
import { getFromAndTo } from '../utils/getFromAndTo';
import { CahierJournalView } from 'containers/CahierJournal/types';
import { ToolbarStructure } from 'components/Layouts/ToolbarStructure';
import { SubDateInfos } from 'containers/CahierJournal/Toolbar/SubDateInfos';
import { DateTitle } from 'containers/CahierJournal/Toolbar/DateTitle';
import { ArrowDateNavigator } from 'containers/CahierJournal/Toolbar/DateNavigator/ArrowDateNavigator';

interface Props {
  date: Date;
  view: CahierJournalView;
  className?: string;
  previewLink: string;
}

export function Toolbar(props: Props) {
  const { date, view, className, previewLink } = props;

  const classrooms = useClassrooms();
  const workingDays = getMutualWorkingDays(classrooms);
  const { from, to } = getFromAndTo(view, date, workingDays);

  return (
    <ToolbarStructure className={className} breakpoint="xl">
      <div tw="hidden sm:block">
        <DateNavigator date={date} workingDays={workingDays} view={view} />
      </div>
      <div tw="flex justify-between text-center lg:mx-2 truncate min-w-0 mb-2 w-full">
        <div tw="block lg:hidden">
          <ArrowDateNavigator.Before
            date={date}
            minimal
            workingDays={workingDays}
            view={view}
            iconSize="lg"
          />
        </div>
        <div tw="mx-auto min-w-0">
          <DateTitle workingDays={workingDays} view={view} date={date} />
          <SubDateInfos view={view} date={date} />
        </div>
        <div tw="block lg:hidden">
          <ArrowDateNavigator.After
            date={date}
            minimal
            workingDays={workingDays}
            view={view}
            iconSize="lg"
          />
        </div>
      </div>
      <div tw="flex justify-end items-center flex-1 gap-x-2">
        <Actions
          previewLink={previewLink}
          from={from}
          to={to}
          date={date}
          view={view}
        />
      </div>
    </ToolbarStructure>
  );
}
